import React, { useState } from "react";
import "./Header.css";
import {
  Menu,
  User,
  Moon,
  LogOut,
  ArrowDownCircle,
  ArrowUpCircle,
  ArrowLeftRight
} from "lucide-react";
import { Link } from "react-router-dom";

export default function Header({ onMenuOpen, userAvatar }) {
  const [open, setOpen] = useState(false);

  return (
    <header className="top-header">

      {/* LEFT SIDE */}
      <div className="left-block">
        <button className="menu-toggle" onClick={onMenuOpen}>
          <Menu size={22} />
        </button>

        <div className="header-logo">
          <img src="/logo.svg" className="qt-logo" alt="logo" />

          <div className="logo-text">
            <div className="qt-title">MintIQ</div>
            <div className="qt-sub">WEB Puzzles PLATFORM</div>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE PROFILE */}
      <div className="profile-wrapper">
        <img
          src={userAvatar || "public/user.svg"}
          className="profile-pic"
          alt="profile"
          onClick={() => setOpen(!open)}
        />

        {open && (
          <div className="profile-dropdown">
            <Link to="/profile" className="dropdown-item">
              <User size={18} />
              Profile
            </Link>

            {/* Deposit */}
            <Link to="/deposit" className="dropdown-item">
              <ArrowDownCircle size={18} />
              Deposit
            </Link>

            {/* Withdraw */}
            <Link to="/withdraw" className="dropdown-item">
              <ArrowUpCircle size={18} />
              Withdraw
            </Link>

            {/* ✅ INTERNAL TRANSFER (ONLY ADDITION) */}
            <Link to="/internal-transfer" className="dropdown-item">
              <ArrowLeftRight size={18} />
              Internal Transfer
            </Link>

            <button className="dropdown-item">
              <Moon size={18} /> Theme
            </button>

            <button className="dropdown-item logout">
              <LogOut size={18} /> Logout
            </button>
          </div>
        )}
      </div>

    </header>
  );
}
